import { Navigate, useParams, useRoutes } from "react-router-dom";

import DeploymentRoutes from "./deployment/routes";
import EditPage from "./edit";
import IndexPage from "./index";
import UserPage from "./user";

export default () =>
  useRoutes([
    { path: "/byType/:type", element: <WithParameters component={IndexPage}/> },
    { path: "/:accountId/user/:userId", element: <WithParameters component={UserPage}/> },
    { path: "/:accountId/user", element: <WithParameters component={UserPage}/> },
    { path: "/:accountId/deployment/*", element: <DeploymentRoutes/> },
    { path: "/:accountId", element: <WithParameters component={EditPage}/> },
    { path: "/", element: <WithParameters component={IndexPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
